// extracted by mini-css-extract-plugin
export default {"providerToggle":"StatsDashboardBox_providerToggle__2hKLV"};